module.exports = __webpack_public_path__ + "de28f44b3b4c5aba4319b58b98bc9d97.fbx";